import { render, staticRenderFns } from "./NotificationsByType.vue?vue&type=template&id=34509c2c"
import script from "./NotificationsByType.vue?vue&type=script&lang=js"
export * from "./NotificationsByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports